import * as Sentry from "@sentry/browser";
import { profile } from "./stores/auth";
import {
  GLITCHTIP_DSN as dsn,
  BUGSNAG_RELEASE_STAGE as environment,
  BUGSNAG_APP_VERSION as release,
} from "#src/env.js";

profile.subscribe((profile) => {
  const { id, username, email } = profile ?? {};
  Sentry.setUser(
    id ? { id, username: username || "anonymous", email } : null,
  );
});

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: 0.01,
    sendClientReports: false, // GlitchTip does not process client reports
    ignoreErrors: [
      // Spurious OpenSeadragon forceRedraw error
      "Cannot set properties of undefined (setting 'forceRedraw')",
      // Email scanning bot errors (Outlook/Exchange safe-link crawlers)
      /Object Not Found Matching Id:.*MethodName:update/,
      // Suspected bot running a non-standard JS runtime
      "Blob is not a constructor"
    ],
    integrations(defaults) {
      // GlitchTip does not support sessions or replays
      return defaults.filter(
        (i) => i.name !== "BrowserSession" && i.name !== "Replay",
      );
    },
  });

  Sentry.setContext("device", {
    name: navigator.platform,
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    screen_width_pixels: window.screen.width,
    screen_height_pixels: window.screen.height,
    screen_density: window.devicePixelRatio,
    orientation: window.screen.orientation?.type?.startsWith("landscape")
      ? "landscape"
      : "portrait",
    processor_count: navigator.hardwareConcurrency || undefined,
    memory_size: navigator.deviceMemory
      ? navigator.deviceMemory * 1024 * 1024 * 1024
      : undefined,
  });

  Sentry.setTags({
    "device.pixelRatio": window.devicePixelRatio,
    "device.screenDimensions": `${window.screen.width}x${window.screen.height}`,
    "device.screenOrientation": window.screen.orientation?.type || "unknown",
    "device.hardwareConcurrency": navigator.hardwareConcurrency || "unknown",
  });

  globalThis.sentry = {
    /**
     * @param {string | Error} message
     */
    notify(message = "Test notification") {
      Sentry.captureException(
        typeof message === "string" ? new Error(message) : message,
        { level: "info" },
      );
    },
  };
}

export { Sentry };
